export const BASE_FONT_SIZE = 10;
export const FOOTER_HEIGHT = '8.7rem';
